import React, { useEffect, useState } from 'react';
import { Users, ChevronDown, ExternalLink } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { contentCalendarAPI } from '../lib/api';
import { getStateMeta } from '../lib/contentStates';

const fmtDate = (f) => (f ? new Date(f + 'T00:00:00').toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }) : 'Sin fecha');

const WorkloadItem = ({ it, onOpen }) => {
  const st = getStateMeta(it.estado);
  return (
    <button type="button" onClick={() => onOpen({ id: it.content_id, client_id: it.client_id })}
      className="w-full flex items-center gap-2 text-left text-xs px-2 py-1.5 rounded-md hover:bg-muted transition-colors"
      data-testid={`workload-item-${it.task_id}`}>
      <Badge variant="outline" className="text-[10px] shrink-0">{it.label}</Badge>
      <span className="truncate flex-1"><b>{it.client_name || 'Sin cliente'}</b> · {it.titulo}</span>
      <span className="text-muted-foreground shrink-0">{fmtDate(it.fecha)}</span>
      <span className="px-1.5 py-0.5 rounded shrink-0" style={{ background: st?.bg, color: st?.fg }}>{st?.label || it.estado}</span>
      <ExternalLink className="w-3 h-3 text-muted-foreground shrink-0" />
    </button>
  );
};

export const TeamWorkload = ({ refreshKey, onOpenPost }) => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => { contentCalendarAPI.workload().then(setRows).catch(() => setRows([])); }, [refreshKey]);

  if (!rows.length) return null;
  const sel = rows.find((r) => r.user_id === open);

  return (
    <Card data-testid="team-workload">
      <CardContent className="p-3 space-y-2">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-xs font-medium text-muted-foreground flex items-center gap-1 mr-1"><Users className="w-3.5 h-3.5" /> Carga por persona:</span>
          {rows.map((r) => (
            <button key={r.user_id} type="button" onClick={() => setOpen(open === r.user_id ? null : r.user_id)}
              className={`flex items-center gap-1.5 px-3 py-1 rounded-full border text-xs transition-colors ${open === r.user_id ? 'bg-primary text-primary-foreground border-primary' : 'hover:bg-muted'}`}
              data-testid={`workload-person-${r.user_id}`}>
              <span>{r.name}</span>
              <span className="font-bold" data-testid={`workload-count-${r.user_id}`}>{r.total}</span>
              {r.total > 0 && <ChevronDown className={`w-3 h-3 transition-transform ${open === r.user_id ? 'rotate-180' : ''}`} />}
            </button>
          ))}
        </div>
        {sel && (
          <div className="border-t pt-2 max-h-64 overflow-y-auto" data-testid="workload-list">
            {sel.items.length ? sel.items.map((it) => <WorkloadItem key={it.task_id} it={it} onOpen={onOpenPost} />)
              : <p className="text-xs text-muted-foreground px-2 py-1">{sel.name} no tiene tareas de publicaciones abiertas.</p>}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
